/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useCallback, useState } from 'react';
import { ContextualHelpListItemModal } from './ContextualHelpListItemModal';

export namespace ContextualHelpListItem {
  export interface Props {
    textScreenId: string;
    textScreenDefinition?: ContextualHelpListItemModal.TextScreenDefinition;
    renderTrigger: (props: { openModal: () => void }) => React.ReactFragment;
  }
}

export const ContextualHelpListItem: React.FC<ContextualHelpListItem.Props> = ({
  renderTrigger,
  ...contextualHelpModalProps
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useCallback(() => setModalOpen(true), []);
  const triggerProps = { openModal };
  return (
    <span>
      {renderTrigger(triggerProps)}
      {modalOpen && (
        <ContextualHelpListItemModal
          {...contextualHelpModalProps}
          contentLabel="Help Dialog"
          isOpen={modalOpen}
          handleClose={() => setModalOpen(false)}
        />
      )}
    </span>
  );
};
